import React from 'react'

import "../App.css"

const Header = () => {
    return (
        <div className="header">
            <h1>Classic Pokémon</h1>
        </div>
    )
}

export default Header
